import * as consumptionMapActions from './consumptionMap'
import * as controlledProductsActions from './controlledProducts'
import * as licenseActions from './license'
import * as menuActions from './menu'
import * as productMapActions from './productMap'
import * as overviewActions from "./overview"
import * as searchActions from './search'
import * as loginActions from './login'
import * as authActions from './auth'
import * as areaActions from './area'
import * as incompatibilityAnalysisActions from './incompatibilityAnalysis'
import * as controlledProductReportActions from './controlledProductReport'
import * as inventoryActions from './inventory'
import * as reportActions from './report'
import * as cabinetProductsActions from './cabinetProducts'
import * as fispqActions from './fispq'
import * as newsActions from './news'
import * as certificateControlActions from  './certificateControl'
import * as measureActions from  './measure'

export {
  consumptionMapActions,
  controlledProductsActions,
  licenseActions,
  menuActions,
  productMapActions,
  overviewActions,
  searchActions,
  loginActions,
  authActions,
  areaActions,
  incompatibilityAnalysisActions,
  controlledProductReportActions,
  inventoryActions,
  reportActions,
  cabinetProductsActions,
  fispqActions,
  newsActions,
  certificateControlActions,
  measureActions
}



// WEBPACK FOOTER //
// ./src/actions/index.js